import { Tooltip } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { StyledEdtLoop16 } from './common.styles';

export const addDynamicFieldMarkerInLabel = (
  label: string | React.ReactNode,
): React.ReactNode => (
  <>
    <Tooltip
      title={
        <FormattedMessage id="templates.dynamic.conditions.fields.project.create.tootlip" />
      }
    >
      <StyledEdtLoop16 />
    </Tooltip>

    {label}
  </>
);
